import { useEffect, useState } from 'react';
import {
  LocationCoordinates,
  useGetLocationCoordinates,
} from 'shared/utils/location/getLocationCoordinates';

export const useUserCoordinates = (
  shouldRequestPermission: boolean,
): LocationCoordinates | null => {
  const { access, hasLocationFetched, getLocationCoordinates } =
    useGetLocationCoordinates();

  const [coordinates, setCoordinates] = useState<LocationCoordinates | null>(
    null,
  );

  useEffect(() => {
    const handleLocationAccess = async () => {
      if (access === 'checking' || hasLocationFetched.current) {
        return;
      }
      hasLocationFetched.current = true;
      const { coordinates: fetchedCoordinates } = await getLocationCoordinates({
        shouldRequestPermission,
      });
      setCoordinates(fetchedCoordinates);
    };

    void handleLocationAccess();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [access]);

  return coordinates;
};
